import { useRef, useState } from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { MathJaxOutput } from "../mathJax/MathJaxOutput";

function RadioGroupAnswer(props: any) {
  const ref = useRef();
  const onValueChange = async (event: any) => {
    setChecked(event.target.value.toString());
  };
  const [checked, setChecked] = useState("");
  return (
    <RadioGroup {...props} ref={ref}>
      {props.answerlist.map((answer: any) => (
        <FormControlLabel
          key={answer}
          label={<MathJaxOutput text={answer} />}
          control={
            <Radio
              value={answer}
              disabled={props.disabled}
              id={props.id}
              checked={
                props.answer ? props.answer === answer : checked === answer
              }
              onChange={onValueChange}
              className={"RadioButtonAnswer"}
            />
          }
        />
      ))}
    </RadioGroup>
  );
}

export default RadioGroupAnswer;
